import { BiContext, ConfigContextProvider, ExperimentsContext, ExternalDataProvider, ForcedStateContext, FormContext, HttpClientContext, TranslationContext, WixRicosViewerContext, AddressFormsContext, getAddressForm, EventsProvider, FieldInitialDataContext, PanoramaContext, FocusedFieldProvider, ScrollProvider } from '@wix/form-fields';
import React, { useMemo, useContext } from 'react';
import { SubmitStatusProvider } from '../../contexts/submit-status-context';
import { HostContext } from '../../tpa/widget/host-context';
import { useFormBi } from '../form/use-form-bi';
export const FormViewerProvider = _ref => {
  let {
    i18n,
    bi,
    biFormFillSessionId,
    form,
    isMobile,
    isEditor,
    isComposer,
    isRTL,
    compId,
    language,
    regionalFormat,
    externalData,
    forcedState,
    instance,
    children,
    httpClient,
    panorama,
    experiments,
    translationNamespace,
    currency,
    userData,
    WixRicosViewer,
    addressTemplates,
    atlasBaseUrl,
    fieldInitialData,
    enableAnimations,
    baseUrl
  } = _ref;
  const translations = useMemo(() => ({
    t: i18n.getFixedT(language, translationNamespace),
    i18n
  }), [language, i18n, translationNamespace]);
  const formBi = useFormBi(form, bi, biFormFillSessionId);
  const host = useContext(HostContext) ?? {};
  const config = useMemo(() => ({
    language,
    regionalFormat,
    instance,
    isMobile,
    currency,
    atlasBaseUrl,
    userData,
    compId,
    baseUrl,
    isEditor,
    isComposer,
    isRTL,
    enableAnimations,
    style: host == null ? void 0 : host.style
  }), [language, regionalFormat, instance, isMobile, currency, atlasBaseUrl, userData, compId, baseUrl, isEditor, isComposer, isRTL, enableAnimations, host == null ? void 0 : host.style]);
  const forcedViewState = useMemo(() => forcedState ?? [], [forcedState]);
  return /*#__PURE__*/React.createElement(HttpClientContext.Provider, {
    value: {
      httpClient
    }
  }, /*#__PURE__*/React.createElement(PanoramaContext.Provider, {
    value: {
      panorama
    }
  }, /*#__PURE__*/React.createElement(TranslationContext.Provider, {
    value: translations
  }, /*#__PURE__*/React.createElement(ScrollProvider, null, /*#__PURE__*/React.createElement(FocusedFieldProvider, null, /*#__PURE__*/React.createElement(FieldInitialDataContext.Provider, {
    value: fieldInitialData
  }, /*#__PURE__*/React.createElement(BiContext.Provider, {
    value: formBi
  }, /*#__PURE__*/React.createElement(ExternalDataProvider, {
    externalData: externalData
  }, /*#__PURE__*/React.createElement(ConfigContextProvider, {
    value: config
  }, /*#__PURE__*/React.createElement(ForcedStateContext.Provider, {
    value: forcedViewState
  }, /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: form
  }, /*#__PURE__*/React.createElement(AddressFormsContext.Provider, {
    value: {
      getCountryAddressForm: country => getAddressForm(addressTemplates, country),
      addressTemplates
    }
  }, /*#__PURE__*/React.createElement(ExperimentsContext.Provider, {
    value: experiments
  }, /*#__PURE__*/React.createElement(EventsProvider, null, /*#__PURE__*/React.createElement(WixRicosViewerContext.Provider, {
    value: WixRicosViewer
  }, /*#__PURE__*/React.createElement(SubmitStatusProvider, null, children))))))))))))))));
};
//# sourceMappingURL=form-viewer-provider.js.map